import React from 'react';
import Component from '@vfuk/core-list-group';
const ListGroup = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ListGroup;
